import { Text } from "@chakra-ui/react";
import { isNumber } from "lodash";
import { useTranslation } from "react-i18next";
import { ContractDataFieldNameDto } from "../../../../autogen/bff-api";
import { displaySum } from "../../../../common/formatting/displaySum";
import { ContractState } from "../../../../common/redux/reducers/contractReducer";
import { requireDataFields } from "../../typeguards";
import { GenericDetailRow, GenericDetails } from "./GenericDetails";
interface Props {
  data: ContractState["contract"];
}

export const Financial = ({ data }: Props) => {
  const { t } = useTranslation();
  const dataFields = requireDataFields(data);
  const rows: GenericDetailRow[] = [];
  const addedFields = dataFields.addedDataFields.map((e) => e.name);
  const noValueProvided = <Text fontStyle={"italic"}>{t("Not provided")}</Text>;
  if (addedFields.includes(ContractDataFieldNameDto.EstimatedValue)) {
    rows.push({
      type: "Data",
      name: t("Estimated value"),
      value: isNumber(dataFields.estimatedValue) ? (
        <Text>{displaySum({ value: dataFields.estimatedValue, currency: data.currency })}</Text>
      ) : (
        noValueProvided
      ),
    });
  }
  if (addedFields.includes(ContractDataFieldNameDto.PricePerMonth)) {
    rows.push({
      type: "Data",
      name: t("Price per month"),
      value: isNumber(dataFields.pricePerMonth) ? (
        <Text>{displaySum({ value: dataFields.pricePerMonth, currency: data.currency })}</Text>
      ) : (
        noValueProvided
      ),
    });
  }
  if (addedFields.includes(ContractDataFieldNameDto.PricePerYear)) {
    rows.push({
      type: "Data",
      name: t("Price per year"),
      value: isNumber(dataFields.pricePerYear) ? (
        <Text>{displaySum({ value: dataFields.pricePerYear, currency: data.currency })}</Text>
      ) : (
        noValueProvided
      ),
    });
  }
  if (addedFields.includes(ContractDataFieldNameDto.TotalPrice)) {
    rows.push({
      type: "Data",
      name: t("Total price"),
      value: isNumber(dataFields.totalPrice) ? (
        <Text>{displaySum({ value: dataFields.totalPrice, currency: data.currency })}</Text>
      ) : (
        noValueProvided
      ),
    });
  }
  if (addedFields.includes(ContractDataFieldNameDto.TotalLiability)) {
    rows.push({
      type: "Data",
      name: t("Total liability"),
      value: isNumber(dataFields.totalLiability) ? (
        <Text>{displaySum({ value: dataFields.totalLiability, currency: data.currency })}</Text>
      ) : (
        noValueProvided
      ),
    });
  }

  return <GenericDetails title={t("Financial")} rows={rows} />;
};
